import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';

window.history.scrollRestoration = 'manual';

const GA_MEASUREMENT_ID = 'G-Z81LJEMC9B';

/** Defer GA so parsing / hydration are not competed with blocking third-party scripts. */
function scheduleGoogleAnalytics() {
  if (process.env.NODE_ENV !== 'production') return;

  const inject = () => {
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);

    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(s);
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(inject, { timeout: 4000 });
  } else {
    window.setTimeout(inject, 2000);
  }
}

scheduleGoogleAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
